import { render, staticRenderFns } from "./MobileCartoonList.vue?vue&type=template&id=66017485&scoped=true&"
import script from "./MobileCartoonList.vue?vue&type=script&lang=js&"
export * from "./MobileCartoonList.vue?vue&type=script&lang=js&"
import style0 from "./MobileCartoonList.vue?vue&type=style&index=0&id=66017485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66017485",
  null
  
)

export default component.exports